import { createSelector } from '@ngrx/store';
import { selectAllNotificationRecipients } from './entity-store-selectors';

export function selectNotificationRecipientById(notificationRecipientId: string) {
  return createSelector(selectAllNotificationRecipients, (recipients) =>
    recipients.get(notificationRecipientId),
  );
}

export function selectNotificationRecipientsByNotificationId(notificationId: string) {
  return createSelector(selectAllNotificationRecipients, (recipients) => {
    return recipients
      .filter((r) => r.notificationId === notificationId)
      .toIndexedSeq()
      .sortBy((n) => n.dateCreated);
  });
}
